import {
  PAY_FREQUENCY_LOOKUP,
  ADD_NEW_USER_DETAILS,
  CHECKOUT_LOOKUP_DATA,
  ADD_RESOLVE_REDIRECT_URL,
  ADD_AARONS_REFERRAL,
} from '../actionTypes';

const initialState = {
  firstName: '',
  ssn4: '',
  checkoutLookupData: {
    appId: null,
  },
};

export default function personal(state = initialState, action) {
  switch (action.type) {
    case PAY_FREQUENCY_LOOKUP: {
      // eslint-disable-next-line camelcase
      const { first_name } = action.payload;
      return {
        ...state,
        firstName: first_name,
      };
    }
    case ADD_NEW_USER_DETAILS: {
      return {
        ...state,
        newUserDetails: {
          ...state.newUserDetails,
          ...action.payload,
        },
      };
    }
    case CHECKOUT_LOOKUP_DATA: {
      return {
        ...state,
        checkoutLookupData: {
          ...state.checkoutLookupData,
          ...action.payload,
        },
      };
    }
    case ADD_RESOLVE_REDIRECT_URL: {
      return {
        ...state,
        resolveRedirectUrl: action.payload,
      };
    }
    case ADD_AARONS_REFERRAL: {
      return {
        ...state,
        aarons: action.payload,
      };
    }
    default:
      return state;
  }
}
